/**
 * API origin resolution for axios — CRM vs IAM microservices.
 * IAM paths include Finlevia customer 360 (`/api/v1/call-center/...`, `/cms/api/cards`).
 */
import { getCrmBackendOrigin, resolveApiOriginForPath, usesDevProxy, } from './backend';
export { DEFAULT_CRM_BACKEND_URL as DEFAULT_CRM_API_ORIGIN } from './backend';
/** CRM API host, or empty when using same-origin `/api/...` (webpack dev-server proxy). */
export const getCrmApiOrigin = getCrmBackendOrigin;
/** Base path for the fetch-based ApiClient (`/api` + endpoint). */
export function getCrmApiBasePath() {
    const origin = getCrmApiOrigin();
    return origin ? `${origin}/api` : '/api';
}
/**
 * Rewrites relative API paths to the correct microservice origin unless already absolute.
 * Dev proxy: leaves paths relative so webpack routes `/api` → CRM and `/user-management` → IAM.
 */
export function resolveCrmApiRequestUrl(url) {
    if (!url || /^https?:\/\//i.test(url)) {
        return url;
    }
    const path = url.startsWith('/') ? url : `/${url}`;
    if (usesDevProxy()) {
        return path;
    }
    const origin = resolveApiOriginForPath(path);
    if (origin) {
        return `${origin}${path}`;
    }
    return path;
}
